import { FC } from 'react';

import { Box, Card, Grid, Typography } from '@mui/material';
import Countdown, { CountdownRenderProps, zeroPad } from 'react-countdown';

export interface ProposalCardProps {
  endDate: number;
  timerFinished?: () => void;
}

const renderer = ({ days, hours, minutes, seconds, completed }: CountdownRenderProps) => {
  if (completed) {
    return null;
  } else {
    return (
      <Grid container spacing={1} justifyContent="center" alignItems="center">
        <Grid item alignItems="center" display="flex" flexDirection="column" mr={2}>
          <Card
            sx={{
              p: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              width: '38px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography color="primary.light" fontWeight="800">
              {zeroPad(days)}
            </Typography>
          </Card>
          <Typography pt={0.5} color="primary.light" variant="caption">
            days
          </Typography>
        </Grid>
        <Grid item alignItems="center" display="flex" flexDirection="column">
          <Card
            sx={{
              p: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              width: '38px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography fontWeight="bold" color="neutral.400">
              {zeroPad(hours)}
            </Typography>
          </Card>
          <Typography pt={0.5} variant="caption" color="neutral.400">
            hours
          </Typography>
        </Grid>
        <Grid item marginTop="-30px">
          :
        </Grid>
        <Grid item alignItems="center" display="flex" flexDirection="column">
          <Card
            sx={{
              p: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              width: '38px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography fontWeight="bold" color="neutral.400">
              {zeroPad(minutes)}
            </Typography>
          </Card>
          <Typography pt={0.5} variant="caption" color="neutral.400">
            min
          </Typography>
        </Grid>
        <Grid item marginTop="-30px">
          :
        </Grid>
        <Grid item alignItems="center" display="flex" flexDirection="column">
          <Card
            sx={{
              p: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              width: '38px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography color="neutral.500" fontWeight="bold">
              {zeroPad(seconds)}
            </Typography>
          </Card>
          <Typography pt={0.5} variant="caption" color="neutral.500">
            sec
          </Typography>
        </Grid>
      </Grid>
    );
  }
};

export const CountdownTimer: FC<ProposalCardProps> = ({ endDate, timerFinished }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Countdown date={endDate} renderer={renderer} onComplete={timerFinished} />
    </Box>
  );
};
